export const URL_BASE = 'api/v1/admin/'
export const NAME_TOKEN = 'TOKEN_AUTH'

let estados = [];
estados['AC'] = 'Acre';
estados['AL'] = 'Alagoas';
estados['AP'] = 'Amapá';
estados['AM'] = 'Amazonas';
estados['BA'] = 'BahiaBahia';
estados['CE'] = 'Ceará';
estados['DF'] = 'Distrito Federal';
estados['ES'] = 'Espírito Santo';
estados['GO'] = 'Goiás';
estados['MA'] = 'Maranhão';
estados['MT'] = 'Mato Grosso';
estados['MS'] = 'Mato Grosso do Sul';
estados['MG'] = 'Minas Gerais';
estados['PA'] = 'Pará';
estados['PB'] = 'Paraíba';
estados['PR'] = 'Paraná';
estados['PE'] = 'Pernambuco';
estados['PI'] = 'Piauí';
estados['RJ'] = 'Rio de Janeiro';
estados['RN'] = 'Rio Grande do Norte';
estados['RS'] = 'Rio Grande do Sul';
estados['RO'] = 'Rondônia';
estados['RR'] = 'Roraima';
estados['SC'] = 'Santa Catarina';
estados['SP'] = 'São Paulo';
estados['SE'] = 'Sergipe';
estados['TO'] = 'Tocantins';

let formatos = []
formatos[1] = "Word";
formatos[2] = "Excel";
formatos[3] = "PowerPoint";
formatos[4] = "PDF";
formatos[5] = "PNG";
formatos[6] = "JPEG";
formatos[7] = "MP4";

let money = {
    decimal: ',',
    thousands: '.',
    prefix: '',
    suffix: '',
    precision: 2,
    masked: false /* doesn't work with directive */
}

let action_messages = {
    create: "Cadastro efetuado com sucesso",
    update: "Cadastro atualizado com sucesso",
    delete: "Cadastro deletado com sucesso",
    update_photo: "Foto atualizada com sucesso"
}

export let ESTADOS = estados
export let FORMATOS = formatos
export let MONEY = money
export let ACTION_MESSAGES = action_messages